module.exports = __webpack_public_path__ + "img/jsonicon.da41a5a5.png";